
import React from 'react';
import './map.css';
import { mapStyle } from './mapStyle';
import _ from 'lodash';

import { getDefaultStyle } from '../../service/regions_foncia';


var L = window.L;

var greenIcon = new L.Icon({
    iconUrl: 'img/marker-icon-green.png',
    iconAnchor: [12, 41]
});

var greyIcon = new L.Icon({
    iconUrl: 'img/marker-icon-grey.png',
    shadowUrl: 'img/marker-shadow.png',
    iconAnchor: [12, 41]
});

class MapSecteurChargeDev extends React.PureComponent {
    constructor(props) {
        super(props);

        this.map = null;

        this.franceLayer = null;
        this.regionLayer = null;
        this.communeLayer = null;

        this.selectedSocMarker = null;
        this.societeMarkers = null;

        this.defaultStyle = getDefaultStyle();

    }

    initFranceLayer(france) {

        this.franceLayer = L.geoJSON(france, {
            style: (feature) => {
                let s = this.defaultStyle[feature.properties.nom];
                return { weight: 0.5, color: this.defaultStyle.color, ...s };
            },
            onEachFeature: (featureR, layerR) => {

                let nomRegion = featureR.properties.nom;

                layerR.on('click', eR => {
                    // click on Region

                    this.props.handleSelectRegion(featureR.properties)

                    fetch(`./output/${nomRegion}/contour-departements.json`)
                        .then(res => res.json())
                        .then(deps => {

                            this.regionLayer = L.geoJSON(deps, {
                                style: (feature) => {
                                    let s = { weight: 1.5, color: this.defaultStyle.color };
                                    return s;
                                }
                            }).addTo(this.map).bringToBack();
                        })
                        .catch(console.error);

                    this.map.fitBounds(layerR.getBounds());
                    this.franceLayer.remove();

                });
            }
        }).addTo(this.map);
    }

    showSocietes(societes) {

        this.societeMarkers.clearLayers();

        for (let i in societes) {
            let societe = societes[i];
            L.marker([societe.latitude, societe.longitude], { societe: societe }).addTo(this.societeMarkers);
        }

        this.societeMarkers.on('click', e => this.onSocMarkerClick(e));
    }

    onSocMarkerClick(e) {
        let societe = e.sourceTarget.options.societe;

        this.selectedSocMarker.setLatLng([societe.latitude, societe.longitude]).addTo(this.map);

        this.props.handleSelectSociete(societe);
    }

    fetchCommunesByDep(metier, codeDep, currentAffectations, allSecteursCd) {

        let nomRegion = this.props.selectedRegion.nom;
        let couleurMetier = this.props.theme.palette[metier] ? this.props.theme.palette[metier].dark : 'green';

        fetch(`./output/${nomRegion}/c${codeDep}.json`)
            .then(res => res.json())
            .then(json => {

                L.geoJSON(json, {

                    style: (feature) => {
                        let s = { weight: 0.5, color: this.defaultStyle.color };

                        let codeCommune = feature.properties.code;

                        if (_.has(allSecteursCd, codeCommune)) {
                            let cdAffecte = allSecteursCd[codeCommune];

                            if (_.find(currentAffectations, { code: codeCommune }))
                                s.fillColor = couleurMetier;
                            else if (cdAffecte && cdAffecte.idIndividu !== this.props.selectedChargeDev.idIndividu)
                                s.fillColor = 'red';
                            else
                                s.fillColor = '#3388ff';
                        } else {
                            s.fill = false;
                        }

                        return s;
                    },
                    onEachFeature: (featureC, layerC) => {

                        let commune = featureC.properties;

                        if (!layerC.options.fill) {
                            layerC.on('click', e => {
                                this.props.handleOpenSnackbar({ severity: 'warning', msg: <><strong>{commune.nom}</strong> n'est pas affecté à cette société</> });
                            });
                        } else if (layerC.options.fillColor === 'red') {
                            let cdAffecte = allSecteursCd[commune.code];

                            layerC.on('click', e => {
                                this.props.handleOpenSnackbar({ severity: 'warning', msg: <><strong>{commune.nom}</strong> affecté à <strong>{cdAffecte.prenom}</strong></> });
                            });
                        } else {

                            if(this.props.selectedSociete.cdAffectable){

                                layerC.on('click', (eC) => {
                                    // click on Commune
    
                                    if (layerC.options.fillColor === couleurMetier) {
                                        // remove selected commune
                                        layerC.setStyle({ fillColor: '#3388ff' });
                                        this.props.handleRemoveCommune(commune.code);
                                    } else {
                                        // select commune
                                        layerC.setStyle({ fillColor: couleurMetier });
                                        this.props.handleSelectCommune(commune);
                                    }
    
                                });
                            } 

                        }

                    }
                }).addTo(this.communeLayer);

            })
            .catch(console.error);

    }

    enableAffectationMode(currentAffectations, metier, allSecteursCd) {

        let soc = this.props.selectedSociete;

        this.societeMarkers.off('click');
        this.societeMarkers.eachLayer(layer => layer.setIcon(greyIcon));

        this.regionLayer.eachLayer(depLayer => {
            let codeDep = depLayer.feature.properties.code;

            // TODO: find codeDep by codePostal
            let firstAffectation = _.isEmpty(currentAffectations) && soc.codePostal.startsWith(codeDep);
            let cdHasSecteurInDep = _.find(currentAffectations, c => c.code.startsWith(codeDep));

            if (firstAffectation || cdHasSecteurInDep) {
                depLayer.setStyle({ fill: false });
                this.fetchCommunesByDep(metier, codeDep, currentAffectations, allSecteursCd);
            } else {
                // click on Departement
                depLayer.on('click', e => {
                    depLayer.off('click');
                    depLayer.setStyle({ fill: false });
                    this.fetchCommunesByDep(metier, codeDep, currentAffectations, allSecteursCd);
                });
            }

        });
    }

    disableAffectationMode() {

        this.communeLayer.clearLayers();

        this.societeMarkers.eachLayer(layer => layer.setIcon(L.Marker.prototype.options.icon));
        this.societeMarkers.on('click', e => this.onSocMarkerClick(e));

        this.regionLayer.eachLayer(depLayer => {
            depLayer.off('click');
            depLayer.setStyle({ fill: true });
        });

    }

    showRegion() {
        this.map.fitBounds(this.regionLayer.getBounds());
    }

    showFrance() {

        this.societeMarkers.clearLayers();
        this.communeLayer.clearLayers();

        this.selectedSocMarker.remove();

        this.regionLayer.remove();
        this.franceLayer.addTo(this.map);
        this.map.fitBounds(this.franceLayer.getBounds());
    }

    componentDidMount() {

        // console.log('this.map', this.map);
        if (this.map) return;

        console.log('init map...');
        let arr = [46.845164, 2.614746];

        this.map = L.map("map", {
            preferCanvas: true,
            attributionControl: false,
            zoom: 6,
            minZoom: 6,
            maxZoom: 15,
            center: arr
        });

        fetch(`./output/france.json`)
            .then(res => res.json())
            .then(france => this.initFranceLayer(france))
            .catch(console.error);

        this.map.zoomControl.setPosition('topright');

        L.maplibreGL({ style: mapStyle(this.props.osmUrls) }).addTo(this.map);

        this.selectedSocMarker = L.marker(arr, { icon: greenIcon, zIndexOffset: 1000 });

        this.societeMarkers = L.featureGroup().addTo(this.map);
        this.communeLayer = L.featureGroup().addTo(this.map);
    }

    render() {
        return <div id="map" className="map"></div>;
    }
}

export default MapSecteurChargeDev;